import React, { useMemo } from 'react';

import { Form } from 'react-bootstrap';

import ActivityFormRadioField from '../ActivityForm/ActivityFormRadioField';
import ActivityFormMultiSelector from '../ActivityForm/ActivityFormMultiSelector/ActivityFormMultiSelector';
import { Activity, Tag } from '../../../types/Activity';
import Disable from "../../utils/Disable";

type Props = {
  selectedTags: string[];
  allTags: string[];
  onChange(tags: string[]): void;
  setIsBookingOptionModalOpen(value?: boolean): void;
  originalActivity: Activity;
  disabled:boolean
};

const ActivitiesTagsForm = ({
  selectedTags,
  allTags,
  onChange,
  setIsBookingOptionModalOpen,
  originalActivity,
  disabled
}: Props) => {
  const onTagChange = (tag: string) => {
    let newTags: string[] = [];
    if (selectedTags.includes(tag)) {
      newTags = selectedTags.filter(t => t !== tag);
    } else {
      if (
        setIsBookingOptionModalOpen &&
        !originalActivity.bookable &&
        tag === 'bookable'
      ) {
        setIsBookingOptionModalOpen();
      }
      newTags = Array.from(new Set([...selectedTags, tag]));
    }
    onChange(newTags);
  };

  const getOtherTags = tagsList => {
    const isFareharbor = tagsList?.find(item => item.type);
    if (isFareharbor) {
      return tagsList
        .filter(
          (tag: Tag) =>
            tag.type !== 'hidden' &&
            tag.type !== 'featured' &&
            tag.type !== 'bookable' &&
            tag.type !== 'bachified'
        )
        .map(item => item.name);
    }

    return tagsList.filter(
      tag =>
        tag !== 'hidden' &&
        tag !== 'featured' &&
        tag !== 'bookable' &&
        tag !== 'bachified'
    );
  };

  const otherSelectedTags = useMemo(() => getOtherTags(selectedTags), [
    selectedTags,
  ]);

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  const allOtherTags = useMemo(() => getOtherTags(allTags), [allTags]);

  const notSelectedOtherTags = useMemo(
    () => allOtherTags.filter(tag => !otherSelectedTags.includes(tag)),
    [allOtherTags, otherSelectedTags]
  );

  return (
    <Disable disabled={disabled}>
      <Form>
        <ActivityFormRadioField
          label='Hidden'
          name='hidden'
          value={!originalActivity || originalActivity.status === 'unpublished'}
          onRadioChange={name => onTagChange(name)}
          options={[
            { label: 'Yes', value: true },
            { label: 'No', value: false },
          ]}
          disabled={true}
        />

        <ActivityFormRadioField
          label='Featured'
          name='featured'
          value={!!selectedTags.find(tag => tag === 'featured')}
          onRadioChange={name => onTagChange(name)}
          options={[
            { label: 'Yes', value: true },
            { label: 'No', value: false },
          ]}
        />

        <ActivityFormRadioField
          label='Bookable'
          name='bookable'
          value={!!selectedTags.find(tag => tag === 'bookable')}
          onRadioChange={name => onTagChange(name)}
          options={[
            { label: 'Bookable', value: true },
            { label: 'Non-bookable', value: false },
          ]}
        />

        <ActivityFormRadioField
          label='Bachified'
          name='bachified'
          value={!!selectedTags.find(tag => tag === 'bachified')}
          onRadioChange={name => onTagChange(name)}
          options={[
            { label: 'Yes', value: true },
            { label: 'No', value: false },
          ]}
        />

        {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          <ActivityFormMultiSelector
            label='Tags'
            caption={'Applied Tags'}
            selectedItems={otherSelectedTags}
            options={notSelectedOtherTags}
            onItemClick={onTagChange}
          />
        }
      </Form>
    </Disable>
  );
};

export default React.memo(ActivitiesTagsForm);
